import { render, staticRenderFns } from "./CommissionCapture.vue?vue&type=template&id=3b7a5f1f&scoped=true"
import script from "./CommissionCapture.vue?vue&type=script&lang=js"
export * from "./CommissionCapture.vue?vue&type=script&lang=js"
import "./CommissionCapture.vue?vue&type=style&index=0&id=3b7a5f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a5f1f",
  null
  
)

export default component.exports